import { r as react } from './common/index-3e0c732a.js';
export { r as default } from './common/index-3e0c732a.js';



var Suspense = react.Suspense;
var useEffect = react.useEffect;
var useState = react.useState;
export { Suspense, useEffect, useState };
